.dots-loader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-l, $spacing-l) 0;
}

.dot {
  width: pxToRem(4);
  height: pxToRem(4);
  margin: 0 var(--spacing-2xs, $spacing-2xs);
  background-color: var(--text-color-primary, text-color(primary));
  border-radius: 50%;
  animation: dot-slide-up 1.4s infinite both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes dot-slide-up {
  0%,
  80%,
  100% {
    opacity: 0.3;
    transform: translate3d(0, 0, 0);
  }
  40% {
    opacity: 1;
    transform: translate3d(0, -4px, 0);
  }
}
